<div class="breadcrumbs">
  <span class="title">Gestione Emergenze <mat-icon style="vertical-align: middle;">keyboard_arrow_right
    </mat-icon> Gestione segnalazioni </span>
</div>
<hr>
<div class="titolo flex-display">
  <div class="flex-display">
    <button mat-stroked-button class="pers" (click)="onNavigate()">
      <mat-icon style="vertical-align: middle;">keyboard_arrow_left</mat-icon>
    </button>
    <div class="denom">
      <span class="h1 upp">Lista segnalazioni per evento {{ denominazione }}</span>
    </div>
  </div>

  <div class="combo">
    <button mat-flat-button color='basic' class="pers2 mleft" *ngIf="acl == 'eell' && abilitatoCompilazione"
      (click)="inserisciSegnalazione()">INSERISCI SEGNALAZIONE</button>
    <button mat-flat-button color='accent' class="pers3 mleft"
      *ngIf="acl == 'eell' && (abilitatoCompilazione || abilitatoCorrezione)"
      (click)="openInviaSegnalazioneDialog()">INVIA SEGNALAZIONI</button>
  </div>


</div>

<div class="flex-row-select" *ngIf="acl == 'dpcpl' || acl == 'dgpe'">
  <div class="flex-row">
    <button mat-flat-button color='accent' class="pers3-select" (click)="showSelect()">
      SELEZIONA OPERAZIONE
    </button>
    <span *ngIf="this.select" [formGroup]="form">
      <mat-form-field appearance="fill" color='accent' class='searchbar operSel'>
        <mat-select [formControlName]="'operazione'" (change)="showCheckbox()">
          <mat-option></mat-option>
          <mat-option *ngFor="let operazione of operazioni" value="{{operazione.idOperazione}}">
            <span>{{ operazione.descOperazione }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
  </div>
  <div class="flex-row">
    <button mat-flat-button color='accent' *ngIf="showButtonEsegui" class="pers3-select mleft"
      (click)="openDialogOperazioneSegnalazioneDialog()">
      ESEGUI
    </button>
  </div>
</div>

<mat-expansion-panel class='rett' hideToggle (opened)="arrowFlag = !arrowFlag" (closed)='arrowFlag = !arrowFlag'>
  <mat-expansion-panel-header class="colorSearch">
    <mat-panel-title class='search'>
      <mat-icon>search</mat-icon>
      <strong class="title">CERCA</strong>
      <mat-icon *ngIf="arrowFlag">keyboard_arrow_up</mat-icon>
      <mat-icon *ngIf="!arrowFlag">keyboard_arrow_down</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="coloredS" [formGroup]="form">

    <div class="flex-row">
      <div class="flex-col">

        <mat-form-field appearance="fill" color='accent' class='searchbar'>
          <mat-label>Codice segnalazione</mat-label>
          <input matInput [formControlName]="'codiceSegnalazione'" type="number">
        </mat-form-field>

        <mat-form-field appearance="fill" color='accent' class='searchbar'>
          <mat-label for="descrizioneSegnalazione">Descrizione segnalazione</mat-label>
          <input matInput [formControlName]="'descrizioneSegnalazione'">
        </mat-form-field>

      </div>

      <div class="flex-col">

        <mat-form-field appearance="fill" color='accent' class='searchbar'>
          <mat-label>Stato</mat-label>
          <mat-select [formControlName]="'stato'">
            <mat-option value=''></mat-option>
            <mat-option value='BOZ'> In bozza </mat-option>
            <mat-option value='COM'> Completata </mat-option>
            <mat-option value='INV'> Inviata </mat-option>
            <mat-option value='RIC'> Ricevuta </mat-option>
            <mat-option value='NOR'> Non ricevuta </mat-option>
            <mat-option value='CON'> Confermata </mat-option>
            <mat-option value='RIF'> Rifiutata </mat-option>
            <mat-option value='IDI'>Inviata al dipartimento</mat-option>
            <mat-option value='ENR'>Emergenza non riconosciuta</mat-option>
            <mat-option value='IDG'>Inviata a DGPE</mat-option>
            <mat-option value='APP'> Apertura post emergenza </mat-option>
            <mat-option value='INP'> Inviata post emergenza </mat-option>
            <mat-option value='CHI'> Chiusa post emergenza </mat-option>
            <mat-option value='RIP'> Ricevuta post emergenza</mat-option>
            <mat-option value='BPE'> In bozza post emergenza</mat-option>
            <mat-option value='COP'> Completata post emergenza</mat-option>
            <mat-option value='RFP'> Rifiutata post emergenza</mat-option>
            <mat-option value='CNP'>Confermata post emergenza</mat-option>
            <mat-option value='IPE'>Inviata al dipartimento post emergenza</mat-option>
            <mat-option value='IDP'>Inviata al dipartimento DGPE post emergenza</mat-option>
            <mat-option value='INT'>Richiesta Integrazione</mat-option>
            <mat-option value='ITP'>Richiesta Integrazione post emergenza</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" color='accent' class='searchbar'>
          <mat-label>Tipologia richiesta</mat-label>
          <mat-select [formControlName]="'tipologia'">
            <mat-option value=''></mat-option>
            <mat-option value='1'>Richieste danni di tipo pubblico</mat-option>
            <mat-option value='2'>Richieste danni di tipo privato</mat-option>
            <mat-option value='3'>Richieste danni di tipo attività economiche</mat-option>
            <mat-option value='4'>Modello libero</mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="flex-col">

        <mat-form-field appearance="fill" color='accent' class='searchbar' *ngIf="acl !== 'eell'">
          <mat-label>Codice ente - descrizione</mat-label>
          <mat-select [formControlName]="'idEnte'">
            <mat-option></mat-option>
            <mat-option *ngFor="let ente of listaEnti" value="{{ente.idEnte}}">
              <span>{{ ente.nodeCode + " - " + ente.descrizione }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" color='accent' class='searchbar' *ngIf="acl !== 'eell'">
          <mat-label for="identificativoInvio">Identificativo invio</mat-label>
          <input type="number" matInput [formControlName]="'identificativoInvio'">
        </mat-form-field>

      </div>

      <div class="flex-col">

        <mat-form-field appearance="fill" color='accent' class='searchbar'>
          <mat-label>Rettificata</mat-label>
          <mat-select [formControlName]="'flRettificata'">
            <mat-option value=''></mat-option>
            <mat-option  value="S">Sì</mat-option>
            <mat-option  value="N">No</mat-option>
          </mat-select>
        </mat-form-field>


      </div>
    </div>
  </div>

  <mat-action-row class='colored'>
    <button mat-stroked-button class="pers2" color="primary" (click)="onExportCsv()">Esporta in Excel</button>
    <button mat-stroked-button class="pers2" color="warn" (click)="onReset()">Reset</button>
    <button mat-raised-button class="pers2" color="accent" (click)="ricercaListaSegnalazioni()">Cerca</button>
  </mat-action-row>
</mat-expansion-panel>


<mat-table [dataSource]="dataSource" matSort matSortActive="codiceSegnalazione" matSortDirection="asc"
  matSortDisableClear>

  <ng-container matColumnDef="codiceSegnalazione">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Codice<br>segnalazione </mat-header-cell>
    <mat-cell [attr.data-label]="'CODICESEGNALAZIONE'" *matCellDef="let element">
      {{element.codiceSegnalazione}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="descrizioneCodiceEnte">
    <mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="acl == 'eell'"> Codice ente - descrizione
    </mat-header-cell>
    <mat-cell [attr.data-label]="'CODICEENTE'" *matCellDef="let element" [hidden]="acl == 'eell'">
      {{element.descrizioneCodiceEnte}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="tipoRichiesta">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Tipo richiesta </mat-header-cell>
    <mat-cell [attr.data-label]="'TIPOLOGIA'" *matCellDef="let element">
      <span *ngIf="element.tipoRichiesta == 1">Richieste danni di tipo pubblico</span>
      <span *ngIf="element.tipoRichiesta == 2">Richieste danni di tipo privato</span>
      <span *ngIf="element.tipoRichiesta == 3">Richieste danni di tipo attività economiche</span>
      <span *ngIf="element.tipoRichiesta == 4">Modello libero</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="descrizioneSegnalazione">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Descrizione segnalazione </mat-header-cell>
    <mat-cell [attr.data-label]="'DESCRIZIONE'" *matCellDef="let element"> {{element.descrizioneSegnalazione}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="stato">
    <mat-header-cell *matHeaderCellDef mat-sort-header> Stato </mat-header-cell>
    <mat-cell [attr.data-label]="'STATO'" *matCellDef="let element">
      <span *ngIf="element.stato == 'BOZ'">In bozza</span>
      <span *ngIf="element.stato == 'COM'">Completata</span>
      <span *ngIf="element.stato == 'INV'">Inviata</span>
      <span *ngIf="element.stato == 'RIC'">Ricevuta</span>
      <span *ngIf="element.stato == 'NOR'">Non ricevuta</span>
      <span *ngIf="element.stato == 'CON'">Confermata</span>
      <span *ngIf="element.stato == 'RIF'">Rifiutata</span>
      <span *ngIf="element.stato == 'IDI'">Inviata al dipartimento</span>
      <span *ngIf="element.stato == 'ENR'">Emergenza non riconosciuta</span>
      <span *ngIf="element.stato == 'IDG'">Inviata a DGPE</span>
      <span *ngIf="element.stato == 'BPE'">In bozza post emergenza</span>
      <span *ngIf="element.stato == 'APP'">Apertura post emergenza</span>
      <span *ngIf="element.stato == 'INP'">Inviata post emergenza</span>
      <span *ngIf="element.stato == 'CHI'">Chiusa post emergenza</span>
      <span *ngIf="element.stato == 'RIP'">Ricevuta post emergenza</span>
      <span *ngIf="element.stato == 'COP'">Completata post emergenza</span>
      <span *ngIf="element.stato == 'CNP'">Confermata post emergenza</span>
      <span *ngIf="element.stato == 'RFP'">Rifiutata post emergenza</span>
      <span *ngIf="element.stato == 'IPE'">Inviata al dipartimento post emergenza</span>
      <span *ngIf="element.stato == 'IDP'">Inviata al dipartimento DGPE post emergenza</span>
      <span *ngIf="element.stato == 'INT'">Richiesta Integrazione</span>
      <span *ngIf="element.stato == 'ITP'">Richiesta Integrazione post emergenza</span>
    </mat-cell>
  </ng-container>


  <ng-container matColumnDef="rettificata">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Rettificata</mat-header-cell>
    <mat-cell [attr.data-label]="'RETTIFICATA'" *matCellDef="let element"> {{element.flRettificata === 'S'?'Sì':'No'}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="idInvio">
    <mat-header-cell *matHeaderCellDef>Identificativo invio</mat-header-cell>
    <mat-cell [attr.data-label]="'IDINVIO'" *matCellDef="let element"> {{element.identificativoInvio}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> Azioni </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span *ngIf="element.codiceSegnalazione !== openToggle" class="material-icons" title="apri/chiudi toolbar"
        (click)="openToolbar(element.codiceSegnalazione,element.stato,element.flRettificata)">more_horiz</span>
      <myp-toolbar *ngIf="element.codiceSegnalazione === openToggle"
        [toolbar]="toolbar" role=toolbar
        [data]="element" (onToolbarEvent)="handleToolbarEvent($event)">
      </myp-toolbar>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="operazione">

    <mat-header-cell *matHeaderCellDef [attr.data-label]="'operazione'">
      <mat-checkbox class="example-margin"
      (change)="setSelezionaTutti($event.checked)"
      [checked]="selezionaTutti==='S' ? true : false">
      </mat-checkbox>
    </mat-header-cell>

    <mat-cell [attr.data-label]="'operazione'" *matCellDef="let element">
      <mat-checkbox class="example-margin"
      (change)="setConfigurationSelezionato(element)"
      [checked]="element.selezionato === 'S' ? true : false">
    </mat-checkbox>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

</mat-table>

<div *ngIf="this.dataSource.counter$.source['value'] === 0">
  <mat-card class="emptyTable">
    <mat-card-content>
      <h6>Non ci sono risultati</h6>
    </mat-card-content>
  </mat-card>
</div>

<mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina"
  [pageSizeOptions]="[3, 5, 10, 100]">
</mat-paginator>
